import {combineReducers, configureStore} from '@reduxjs/toolkit'
import productReducer from './product/productSlice'
import userReducer from './features/auth/userSlice'
import {persistReducer, persistStore} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
const rootReducer=combineReducers({
    product:productReducer,
    user:userReducer
})

const persistConfig={
    key:'root',
    version:1,
    storage
}

const persistedReducer=persistReducer(persistConfig,rootReducer)
export const store=configureStore({
    reducer:
         persistedReducer
    ,
    middleware:(getDefaultMiddleware)=>getDefaultMiddleware({
        serializableCheck:false
    })
})

export const persistor=persistStore(store)